import LegalLayout from "./LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum">
      <section className="space-y-8 font-serif text-lg text-charcoal leading-relaxed">
        <div>
          <p className="text-xl">
            Stephanie Dreier<br />
            Saritscher Hauptstraße 12<br />
            02699 Neschwitz
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-3">Kontakt</h2>
          <p>
            E-Mail:{" "}
            <a href="mailto:hallo@oratiorede.de" className="underline underline-offset-4 hover:text-umber">
              hallo@oratiorede.de
            </a>
            <br />
            Nachricht:{" "}
            <a href="/kontakt" className="underline underline-offset-4 hover:text-umber">
              Kontaktformular
            </a>
          </p>
          <p className="text-base text-ink mt-3">
            Anfragen werden in der Regel innerhalb eines Werktages beantwortet.
          </p>
        </div>

        <div>
          <h2 className="font-serif text-xl text-umber mb-3">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          <p className="text-base">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>

        <p className="text-sm text-ink/60 pt-8 border-t border-umber/10">
          Quelle: <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="underline">eRecht24</a>
        </p>
      </section>
    </LegalLayout>
  );
}
